import { getConfig, loadConfig } from '../utils/configLoader';

let configLoaded = false;

// Function to ensure config is loaded
const ensureConfigLoaded = async () => {
  if (!configLoaded) {
    await loadConfig();
    configLoaded = true;
  }
};

// Function to get config values safely
const getConfigValue = (key) => {
  const config = getConfig();
  return config?.[key];
};

// API and basic settings
export const getBaseApiUrl = async () => {
  await ensureConfigLoaded();
  return getConfigValue('API_BASE_URL');
};
// phone Numer
export const getPhoneNumber = async () => {
  await ensureConfigLoaded();
  return getConfigValue('company_phone_number');
};

export const getCurrency = async () => {
  await ensureConfigLoaded();
  return getConfigValue('CURRENCY');
};

export const getMainLabel = async () => {
  await ensureConfigLoaded();
  return getConfigValue('MAIN_LABEL');
};

// App Info
export const getAppTitle = async () => {
  await ensureConfigLoaded();
  return getConfigValue('APP_TITLE');
};

export const getAppIcon = async () => {
  await ensureConfigLoaded();
  return getConfigValue('APP_ICON');
};

// Development Settings
export const getShowConsoleLog = async () => {
  await ensureConfigLoaded();
  return getConfigValue('SHOW_CONSOLE_LOG');
};

// Utility function for conditional console logging
// Only logs in development mode, regardless of config
export const log = async (...args) => {
  if (process.env.NODE_ENV === 'development') {
    const showLog = await getShowConsoleLog();
    if (showLog) {
      console.log(...args);
    }
  }
};

export const logError = async (...args) => {
  if (process.env.NODE_ENV === 'development') {
    const showLog = await getShowConsoleLog();
    if (showLog) {
      console.error(...args);
    }
  }
};

export const logWarn = async (...args) => {
  if (process.env.NODE_ENV === 'development') {
    const showLog = await getShowConsoleLog();
    if (showLog) {
      console.warn(...args);
    }
  }
};

// Section Labels
export const getTopTable = async () => {
  await ensureConfigLoaded();
  return getConfigValue('TOP_TABLE');
};

// Footer Information
export const getFooterAboutTitle = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_ABOUT_TITLE');
};

export const getFooterAboutText = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_ABOUT_TEXT');
};

export const getFooterMission = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_MISSION');
};

export const getFooterCompany = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_COMPANY');
};

export const getFooterLinks = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_LINKS');
};

export const getFooterContactTitle = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_CONTACT_TITLE');
};

export const getFooterAddress = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_ADDRESS');
};

export const getFooterPhone = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_PHONE');
};

export const getFooterFax = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_FAX');
};

export const getFooterEmail = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_EMAIL');
};

export const getFooterCopyright = async () => {
  await ensureConfigLoaded();
  return getConfigValue('FOOTER_COPYRIGHT');
}; 